module.exports = __webpack_public_path__ + "static/unity-website-0ae9423042a36bce3a5ebc091d9f9e70.png";